import React, {
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import DataTable from "../../Components/DataTable/DataTable";
import FilterComponent from "../../Components/FilterComponent/FilterComponent";
import { ManageApis } from "../../AppServices/ManageApi";
import {
  convertToUTC,
  downloadDifferentType,
  lengthValidation1,
  preventSpecialChars,
  preventSpecialCharsandAllowHyphen,
  preventSpecialCharsandNum,
  sanitizePhoneNumber2,
  validateLength,
} from "../../Common/Utils/Utils";
import { globalContext } from "../../App";
import moment from "moment";
import DownloadComponent from "../../Components/DownloadComponent/DownloadComponent";
import AlertBox from "../../Components/AlertBox/AlertBox";
import { AlertinitialValue, casbaStatus, dataColumn, dataColumnCsv, defaultColumnWidths, downloadOptions, ExpandedCollectionData, ExpandedSchemeData, getDownloadFormat, paymentFilters, upiColumn, upiColumnCsv } from "../../Common/Utils/intialValues";
import ConfirmationModal from "../../Components/ModalComponent/ConfirmationModal/ConfirmationModal";
import { getStatusInfo} from "./GetStatusStyle";


function Collections() {
  const CurrentDate=`${moment().format('DD-MM-YYYY')}`;
  const PrevDate=`${moment().subtract(1, 'days').format('DD-MM-YYYY')}`;
  const [selectedTab, setSelectedTab] = useState("collections");
  const [collectionsTableVisible, setCollectionsTableVisible] = useState(true);
  const [VisibleschemeDetails, setVisibleschemeDetails] = useState(false);
  const [errorMsg, setErrorMsg] = useState({});
  const [TableData, setTableData] = useState([]);
  const [pageSize, setpageSize] = useState(10);
  const [TotalCount, setTotalCount] = useState();
  const [currentPage, setcurrentPage] = useState(1);
  const [isExpand, setisExpand] = useState('');
  const { setIsLoader, isBranchAdmin,userPermissions } = useContext(globalContext);
  const [showAlert, setShowAlert] = useState(AlertinitialValue);
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState({})
  const [isPermitted,setIsPermitted]=useState({
    update:false,
    delete:false
  })
  const [remark,setRemark]=useState('')

  const [filterVal,setFilterVal]=useState({
    agentId:"",
    agentName:"",
    Date:[PrevDate,CurrentDate],
    casba:"",
    chittyId:"",
    ChittalNo:"",
    postId:"",
    transactionId:"",
    payment_mode:"",
    customer_name:"",
    amountPaid:"",
    remark:""
  })
  const [branchState, setBranchState] = useState([]);
  const [RegionState, setRegionState] = useState([]);

  const [isFilterReset, setIsFilterReset] = useState(false);
  const [filter,setFilter]=useState(false)
  const previousTab = useRef(selectedTab);
  const collectionData = [
    {
      title: "Sl No",
      dataIndex: "key",
      sorter: (a, b) => {
        if (a.key > b.key) {
          return 1;
        }
        if (a.key < b.key) {
          return -1;
        }
        return 0;
      },
      render: (text) => text || "NA",
    },
    {
      title: "Transaction ID",
      dataIndex: "transactionId",
      render: (text) => text || "NA",
    },
    {
      title: "DC Agent ID",
      dataIndex: "agentId",
      render: (text) => text || "NA",
    },
    {
      title: "DC Agent Name",
      dataIndex: "agentName",
      render: (text) => text || "NA",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      render: (text) => text || "NA",
    },
    
    {
      title: "Branch",
      dataIndex: "branchName",
      render: (text) => text || "NA",
    },

    {
      title: "Amount Collected",
      dataIndex: "amountPaid",
      sorter: (a, b) => a.amountPaid - b.amountPaid,
      render: (text) => text || "NA",
    },
    {
      title: "Collected Date",
      dataIndex: "created_date",
      dataIndex: "created_date",
      render: (text) => text || "NA",
    },
    {
      title: "Status",
      dataIndex: "collection_status",
      render: (text, record, index) => {
        const { statusText, backgroundColor, color } = getStatusInfo(record);


        return (
          <div className="d-flex align-items-center gap-2">
            <span
              style={{
                backgroundColor: backgroundColor,
                display: "block",
                textAlign: "center",
                fontWeight: "600",
                color: color,
                borderRadius: "20px",
                minWidth: "100px",
                maxWidth: "100px",
              }}
            >
              {statusText}
            </span>
            {isPermitted.update && (record?.paidByCheque == 0 && (record?.payment_status === 0 || record?.payment_status === 1)) && <i style={{border:"3px solid", borderRadius:15,padding:5}} class="fas fa-redo text_master" onClick={(e) => { handleCheckPaymentStatus(e, record)}}></i>}
          </div>
        );
      },
    },

    {
      title: "",
      dataIndex: "",
      render: (text, record, index) => {
        return (
          <div>
            {isExpand == record._id ? (
              <i className="fas fa-chevron-up text_master"></i>
            ) : (
              <i className="fas fa-chevron-down text_master"></i>
            )}
          </div>
        );
      },
    },
  ];

  //Scheme Details
  const SchemeData = [
    {
      title: "Sl No.",
      dataIndex: "key",
      sorter: (a, b) => {
        if (a.key > b.key) {
          return 1;
        }
        if (a.key < b.key) {
          return -1;
        }
        return 0;
      },
      render: (text) => text || "NA",
    },
    {
      title: "Transaction ID",
      dataIndex: "transactionId",
      render: (text) => text || "NA",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      render: (text) => text || "NA",
    },

    {
      title: "Amount Collected",
      dataIndex: "amountPaid",
      sorter: (a, b) => a.amountPaid - b.amountPaid,
      render: (text) => text || "NA",
    },
    {
      title: "Cash Amount",
      dataIndex: "paidByCash",
      sorter: (a, b) => a.paidByCash - b.paidByCash,
      render: (text) => text || "NA",
    },
    {
      title: "Cheque Amount",
      dataIndex: "paidByCheque",
      sorter: (a, b) => a.paidByCheque - b.paidByCheque,
      render: (text) => text || "NA",
    },
    {
      title: "UPI Amount",
      dataIndex: "paidByUPI",
      sorter: (a, b) => a.paidByUPI - b.paidByUPI,
      render: (text) => text || "NA",
    },
    {
      title: "Collected Date",
      dataIndex: "created_date",
      render: (text) => text || "NA",
    },

    {
      title: "Casba Sync Status",
      dataIndex: "collection_status",
      render: (text, record, index) => {
        const { statusText, backgroundColor, color } = getStatusInfo(record);
    

        return (
          <div className="d-flex align-items-center gap-2">
            <span
              style={{
                backgroundColor: backgroundColor,
                display: "block",
                textAlign: "center",
                fontWeight: "600",
                color: color,
                borderRadius: "20px",
                minWidth: "100px",
                maxWidth: "100px",
              }}
            >
              {statusText}
            </span>
            {statusText === "Processing" &&  <i class="fas fa-redo text_master " onClick={(e) => { handleCheckPaymentStatus(e, record,"check")}}></i>}
            {isPermitted.update && (record?.paidByCheque == 0 && (record?.payment_status === 0 || record?.payment_status === 1)) &&    <i style={{border:"3px solid", borderRadius:15,padding:5}} class="fas fa-redo text_master" onClick={(e) => { handleCheckPaymentStatus(e, record)}}></i>}

          </div>
        );
      },
    },
    {
      title: "",
      dataIndex: "",
      render: (text, record, index) => {
        // console.log(text, record, index);
        return (
          <div>
            {isExpand == record._id ? (
              <i className="fas fa-chevron-up text_master"></i>
            ) : (
              <i className="fas fa-chevron-down text_master"></i>
            )}
          </div>
        );
      },
    },
  ];


  //Filtering Section
  let filterCollectionList = [
    {
      type: "text",
      placeholder: "Agent ID",
      name: "agentId",
    },

    {
      type: "text",
      placeholder: "Agent Name",
      name: "agentName",
    },
    {
      type: "text",
      placeholder: "Transaction ID",
      name: "transactionId",
    },
    {
      type: "text",
      placeholder: "Customer Name",
      name: "customer_name",
    },
    {
      type: "text",
      placeholder: "Amount Paid",
      name: "amountPaid",
    },
    {
      type: "date-range",
      placeholder: "Date",
      name: "Date",
      value:filterVal.Date
    },
    {
      type: "select",
      placeholder: "Payment Mode",
      name: "payment_mode",
      options: paymentFilters,
      labelKey: "payment_mode",
      valueKey: "payment_mode",
    },
    {
      type: "select",
      placeholder: "Region",
      name: "region_name",
      options: [...RegionState],
      api: global.getAllRegions,
      labelKey: "region_name",
      valueKey: "region_code",
      state: setRegionState,
    },
    !isBranchAdmin && {
      type: "select",
      placeholder: "Branch Name",
      name: "branch_name",
      options: [...branchState],
      api: global.getAllBranches,
      labelKey: "branch_name",
      valueKey: "branch_id",
      state: setBranchState,
    },
  ].filter(Boolean);

  const [filterChange, setFilterChange] = useState(filterCollectionList);


  let filterSchemeData = [
    {
      type: "text",
      placeholder: "Chitty Number",
      name: "chittyId",
    },
    // {
    //   type: "text",
    //   placeholder: "Post Id",
    //   name: "postId",
    // },
    {
      type: "text",
      placeholder: "Chittal No",
      name: "ChittalNo",
    },
    {
      type: "date-range",
      placeholder: "Date",
      name: "Date",
      value: filterVal.Date,
    },
    {
      type: "select",
      placeholder: "Casba Sync Status",
      name: "casba",
      options: [...casbaStatus],
    },
  ];

  useEffect(()=>{
    fetchTableDatas()
    },[pageSize,currentPage])

  useEffect(() => {
    const UpdatePermission = userPermissions.some(
      permission => permission.label === 'UpdatePaymentPermission'
    );
    const DeletePermission = userPermissions.some(
      permission => permission.label === 'DeleteCollectionPermission'
    );
  
    setIsPermitted({
      update:UpdatePermission,
      delete:DeletePermission
    });
  }, [userPermissions]);

  useEffect(() => {
    if (collectionsTableVisible) setFilterChange(filterCollectionList);
    else setFilterChange(filterSchemeData);
  }, [filterCollectionList, collectionsTableVisible]);



  const handleCheckPaymentStatus = async(e,record,action) =>{
    try {
      if(e)
        e?.stopPropagation()
      setIsLoader(true)
      const body = action === "check" ? { id: record._id } : { collection_id: record._id };
      let path = action === "check" ? global.checkCollectionStatus : global.updateUPIStatus;
      const result = await ManageApis("post", path, body); 
      if(result?.status_code === 200){
        if(result?.response_data?.status){
          setShowAlert({
            show: true,
            type: "",
            message: result?.response_data?.message,
            isSuccess:true
          });
        } else {
          setShowAlert({
            show: true,
            type: "",
            message: "The status has not been updated.",
            isFalse: true,
          });
        }
      }
      fetchTableDatas()
      setIsLoader(false)
    } catch (error) {
    setIsLoader(false)
      
    }
  }

  
  const handleDelete=async()=>{
    try {
      setRemark(false)
      setIsLoader(true);
      if(!filterVal.remark) return;
     const body ={
      collection_item_id:remark?._id,  
      remarks:filterVal.remark
     }
     const result = await ManageApis("post", global.deleteCollection, body); 
      if(result?.response_data?.status){
        setShowAlert({
          show: true,
          type: "",
          message: result?.response_data?.message,
          isSuccess:true
        });
      } else {
        setShowAlert({
          show: true,
          type: "",
          message: result?.response_data?.message || result?.message,
          isFalse: true,
        });
      }
    } catch (error) {
      console.log(error);
    }finally{
      setIsLoader(false)
      setFilterVal((prev)=>({
        ...prev,
        remark:""
      }))
    }
  }
  

  const handleTabChange = (tab) => {
    if (tab === selectedTab) {
      return;
    }
    setTableData([]);
    setSelectedTab(tab);
    setisExpand(prev=>"")
    setTotalCount()
    if (tab === "collections") {
      setCollectionsTableVisible(true);
      setVisibleschemeDetails(false);
      setFilterChange(filterCollectionList);
    } else if (tab === "schemeDetails") {
      setCollectionsTableVisible(false);
      setVisibleschemeDetails(true);
      setFilterChange(filterSchemeData);
    }
    handleFilterReset()
  };



  const handleOnChange = (value, label, index, name) => {
    let updatedValue = value;
  
    // Clear the error message for the current field
    setErrorMsg((prev) => ({
      ...prev,
      [name]: "",
    }));

      // If the value is cleared (e.g., reset to an empty string or null), handle it properly
  if (!value || value === "") {
    updatedValue = ""; // Ensure empty value is stored
  }
  
    // Apply specific validations or transformations
    switch (name) {
      case "agentName":
      case "customer_name":
        let lenght = name == "remark" ? 80 : 30;
        updatedValue = preventSpecialCharsandNum(validateLength(value, lenght));
        setErrorMsg((prev) => ({
          ...prev,
          [name]: lengthValidation1(updatedValue, 3),
        }));
        break;
  
      case "agentId":
      case "postId":
      case "ChittalNo":
      case "amountPaid":
        updatedValue = sanitizePhoneNumber2(validateLength(value, name === "ChittalNo" ? 5 : 15));
        break;
  
      case "chittyId":
        updatedValue = validateLength(value, 16);
        break;

      case "Date":
        updatedValue = value ? value : [PrevDate,CurrentDate]
        break;

        case "remark":
        updatedValue = preventSpecialChars(validateLength(value, 60));
        break;

        case "transactionId":
          const regex = /^TX-[a-zA-Z0-9]{6,15}$/;
          updatedValue = preventSpecialCharsandAllowHyphen(validateLength(value, 15));
          setErrorMsg((prev) => ({
            ...prev,
            [name]: !value
              ? ""
              : regex.test(updatedValue)
              ? "" 
              : "Enter a valid transaction ID (e.g., TX-123abc)", 
          }));
          break;
  
      case "region_name":
        filterSection(name, value);
        break;
  
      default:
        break;
    }
  
    // Update the filter value
    setFilterVal((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  
  };
  

  const filterSection=async(name,val)=>{
    try {
      let path;
      let apiCalls=[];
     let reqstBody;
     let filterData;
        if(name=== 'region_name'){
          filterData=filterChange.filter((items)=>items.name === 'branch_name');
          path=filterData[0].api+`?regionCode=${val}`
        }else if(name ==='branch_name'){
          filterData=filterChange.filter((items)=>items.name === 'region_name');
        }
        apiCalls.push(commonApiCall({ path, reqstBody, method: "get" }));
      const response =await Promise.all(apiCalls);
      response.forEach(({ message, response_data }) => {
        if (message === "Success") {
          
          const { data } = response_data || {};
          const mappedData =  data.map((item) => {
            return {
            label: item[filterData[0].labelKey],
            value: item[filterData[0].valueKey],
          }});
          setBranchState(mappedData)
        }
      });
    } catch (error) {
      // console.log(error);
    }
  }

  const handleFilterReset = () => {
    setFilterVal({
      agentId:"",
      agentName:"",
      casba:"",
      chittyId:"",
      ChittalNo:"",
      postId:"",
      Date:[PrevDate,CurrentDate],
      customer_name:"",
      amountPaid:"",
      payment_mode:"",
      transactionId:"",
      remark:"",
    })
    setcurrentPage(1)
    setErrorMsg({});
    setIsFilterReset(true);
  };

  const formatForPdfData = (data, payment_mode) => {
    try {
      const sumTotal = { paidByUPI: 0, paidByCash: 0, paidByCheque: 0, amountPaid: 0 };
      let serialNumber = 1;
  
      const formatRow = (row, collectionMode, paidAmount, paymentDetails, branchName, createdDate) => {
        const formattedRow = { ...row };
        formattedRow.amountPaid = paidAmount;
        formattedRow.collectionMode = collectionMode;
        formattedRow.amountPaid = getValidAmount(paidAmount);
        formattedRow.chittyId = paymentDetails[0].item.chittyId;
        formattedRow.chittalNo = paymentDetails[0].item.chittalNo;
        formattedRow.branchName = branchName;
        formattedRow.created_date = createdDate;
        formattedRow.key = serialNumber++;
        formattedRow.status = getStatusInfo(formattedRow)?.statusText;
        return formattedRow;
      };
  
      data = data.flatMap((row) => {
        const formattedRows = [];
        const { paymentDetails, branchDetails, created_date, paidByCash, paidByCheque, paidByUPI, payment_status } = row;
  
        // Handle branch details and other missing values
        const branchName = branchDetails?.branchName || "NA"; // Default to "NA" if no branch name
        const createdDate = created_date ? moment(created_date).format("DD-MM-YYYY h:mmA") : "NA"; // Default to "NA" if no date
  
        // Function to add formatted rows for each payment mode
        const addRow = (paymentType, amount, collectionMode) => {
          if (typeof amount === "number" && amount > 0) {
            const formattedRow = formatRow(row, collectionMode, amount, paymentDetails, branchName, createdDate);
            if (payment_status >= 2) sumTotal.amountPaid += formattedRow.amountPaid;
            sumTotal[`${paymentType}Total`] += formattedRow.amountPaid;
            formattedRows.push(formattedRow);
          }
        };
  
        // Add rows based on payment mode
        if (payment_mode !== 2) addRow("paidByCash", paidByCash, "Cash");
        if (payment_mode !== 1) addRow("paidByCheque", paidByCheque, "Cheque");
        if (payment_mode !== 1 && payment_mode !== 2) addRow("paidByUPI", paidByUPI, "UPI");
  
        return formattedRows;
      });
  
      // Add total summary at the end
      data.push(sumTotal);
      return data;
    } catch (error) {
      console.error("Error formatting data:", error);
      return data;
    }
  };

  const formatPdfDataForUpi = (data) => {
    try {
      // Filter only UPI payments
      const upiPayments = data.filter((row) => Number(row.paidByUPI) > 0 && row.payment_status >= 2);
  
      // Group payments by transactionId
      const groupedPayments = upiPayments.reduce((acc, payment) => {
        const transactionId = payment.transactionId || "Unknown"; // Handle missing transaction IDs
        if (!acc[transactionId]) {
          acc[transactionId] = {
            transactionId,
            amountPaid: 0,
            branchName: payment?.branchDetails?.branch_name || payment?.branchDetails?.branchName || payment?.paymentDetails[0]?.item?.branch || "NA",
            agentName: payment.agentName || "NA",
            agentId: payment.agentId || "NA",
            customerName: payment.customerName || "NA",
            created_date: payment.created_date
              ? moment(payment.created_date).format("DD-MM-YYYY h:mmA")
              : "NA",
          };
        }
  
        // Accumulate amountPaid
        acc[transactionId].amountPaid = payment.paidByUPI;
  
        return acc;
      }, {});
  
      // Convert the grouped object into an array for easier processing
      return Object.values(groupedPayments).map((group) => ({
        transactionId: group.transactionId,
        amountPaid: group.amountPaid,
        branchName: group.branchName,
        agentName: group.agentName,
        agentId: group.agentId,
        customerName: group.customerName,
        created_date: group.created_date,
      }));
    } catch (error) {
      console.error("Error grouping UPI payments:", error);
      return [];
    }
  };
  
  
  

  const getValidAmount = (value) =>{
    try {
      if(typeof value === "number"){
        return value
      } 
      return 0
    } catch (error) {
      return 0
    }
  }

  const handleRemark=async(record)=>{
  setRemark(record)
  }
  
  

  function expandedRowRender(record) {
    const filteredData = TableData.filter((item) => item?.key === record?.key);
  
    if (filteredData.length === 0) return null; 
  
    const firstData = filteredData[0]; // Store first filtered item
  
    const groupedData = firstData?.paymentDetails?.reduce((acc, curr) => {
      const key = `${curr?.item?.chittyId}-${curr?.item?.chittalNo}`;
  
      const { payment_status, posting_status, collection_status } = firstData;
  
      if (!acc[key]) {
        acc[key] = {
          amountToBePaid: curr?.amountToBePaid,
          branchDetails: curr?.item?.branch,
          item: curr?.item,
          payments: [],
          status: { payment_status, posting_status, collection_status },
        };
      }
  
      // Append payment details with IDs
      if (curr?.paidByCash) {
        acc[key].payments.push({ type: "Cash", amount: curr.paidByCash, _id: curr._id });
      }
      if (curr?.paidByCheque) {
        acc[key].payments.push({ type: "Cheque", amount: curr.paidByCheque, _id: curr._id });
      }
      if (curr?.paidByUPI) {
        acc[key].payments.push({ type: "UPI", amount: curr.paidByUPI, _id: curr._id });
      }
  
      return acc;
    }, {});
  
    const selectedDataSet = Object.values(groupedData) || [];
  
    if (selectedTab == "schemeDetails") {
      return (
        <div
         style={{ width: "46%", paddingLeft: "0px" }}
          className="expand_inner_table"
          >
          <DataTable columns={ExpandedSchemeData} rowData={selectedDataSet} />
        </div>
      );
    } else if (selectedTab == "collections") {
      return (
        <div
         style={{ width: "95%", paddingLeft: "0px" }}
          className="expand_inner_table"
          >
          <DataTable
           columns={ExpandedCollectionData(handleRemark,isPermitted.delete)}
            rowData={selectedDataSet}
             />
        </div>
      );
    }
  
    return null; 
  }
  useEffect(() => {
    if (isFilterReset) {
      setFilter(false);
      setIsFilterReset(false);
    }
  }, [isFilterReset]);


  useEffect(()=>{
    if (previousTab.current ===selectedTab) {
      fetchTableDatas(1)
      previousTab.current = selectedTab;
    }
  },[selectedTab])

  const fetchTableDatas = async (page) => {
    try {
      setIsLoader(true)
      let path;
      let reqstBody = {};
      let apiCalls = [];
      const agentIdValue = filterVal.agentId;
      const agentNameValue = filterVal.agentName;
      const chittalNoValue = filterVal.ChittalNo;
      const postIdValue = filterVal.postId;
      const chittyIdValue = filterVal.chittyId;
      const startDateValue =filterVal?.Date?.[0]? convertToUTC(filterVal?.Date?.[0]): moment().subtract(1, 'days').format('DD-MM-YYYY');
      const endDateValue =filterVal?.Date?.[1] ? convertToUTC(filterVal?.Date?.[1]):moment().format('DD-MM-YYYY');
      const casbaStatusValue = filterVal.casba;
      const transactionId = filterVal.transactionId;
      const startingIndex = (currentPage - 1) * pageSize + 1;
      const branch_name = filterVal.branch_name;
      const Region_name = filterVal.region_name;
      const payment_mode = filterVal.payment_mode;
      const customer_Name=filterVal.customer_name;
      const Amount=filterVal.amountPaid;
      if (page) {
        setcurrentPage((prev) => page);
      }
      switch (selectedTab) {
        case "collections":
          let params = agentNameValue ? `agentName=${agentNameValue}&` : "";
          params = params + (agentIdValue ? `agentId=${agentIdValue}&` : "");
          params =
            params + (transactionId ? `transactionId=${transactionId}&` : "");
          params =
            params +
            (startDateValue && endDateValue
              ? `startDate=${startDateValue}&endDate=${endDateValue}&`
              : "");
          params = params + (branch_name ? `branchId=${branch_name}&` : "");
          params = params + (Region_name ? `regionCode=${Region_name}&` : "");
          params = params + (payment_mode ? `paymentMode=${payment_mode}&` : "");
          params = params + (customer_Name ? `customerName=${customer_Name}&` : "");
          params = params + (Amount ? `amountPaid=${Amount}&` : "");
          path =
            global.getCollectionDetails +
            `?${params}page=${currentPage}&limit=${pageSize}`;
          reqstBody = {};
          break;
        case "schemeDetails":
          let params1 = chittalNoValue ? `chittalNo=${chittalNoValue}&` : "";
          params1 =
            params1 + (chittyIdValue ? `chit_id=${chittyIdValue}&` : "");
          params1 =params1 + (startDateValue && endDateValue ? `startDate=${startDateValue}&endDate=${endDateValue}&` : "");
            params1 = params1 + (postIdValue ? `syncId=${postIdValue}&` : "");
            params1 = params1 + (casbaStatusValue ? `status=${casbaStatusValue}&` : "");
          path = global.getSchemeDetails +`?${params1}page=${currentPage}&limit=${pageSize}`;
          reqstBody = {};
          break;
        default:
          break;
      }

      apiCalls.push(commonApiCall({ path, reqstBody, method: "get" }));
      const responses = await Promise.all(apiCalls);

      responses.forEach(({ message, response_data }) => {
        if (message === "Success") {
          const { data } = response_data || {};
          setTableData(
            data.docs.map((itm, index) => ({
              ...itm,
              key: startingIndex + index,
              created_date: itm.created_date
                ? moment(itm.created_date).format("DD-MM-YYYY h:mmA")
                : "",
              branchName: itm?.paymentDetails[0]?.item?.branch || itm?.branchDetails?.branch_name,
              RegionName:itm?.branchDetails?.parent_branch?.name
            }))
          );
          setTotalCount(data.total || data.totalDocs);
          setpageSize(parseInt(data.limit));
        } else {
        }
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  async function commonApiCall({ path, reqstBody, method = "post" }) {
    if(!path) return 
    try {
      const result = await ManageApis(method, path, reqstBody);
      // console.log("........====", result.response_data.data);
      return result;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

 
  function onChangeTable(current, size) {
    setcurrentPage(current);
    setpageSize(parseInt(size));
  }

  const filterListOptions = async () => {
    try {
      if (!filter) {
        let apiCalls = [];
        const filteredDataList = filterChange.filter((items) => items.api);
        for (const filter of filterChange) {
          const apiUrl = filter.api;
          const path = apiUrl;
          let reqstBody = {};
          if (path)
            apiCalls.push(commonApiCall({ path, reqstBody, method: "get" }));
        }
        const responses = await Promise.all(apiCalls);

        responses.forEach(({ message, response_data }, index) => {
          const filter = filteredDataList[index];
          if (message === "Success") {
            const { data } = response_data || {};
            const mappedData = data.map((item) => {
              return {
                label: item[filter.labelKey],
                value: item[filter.valueKey],
                all: item,
              };
            });

            filter.state(mappedData);
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getDownloadDetails = (type, downloadFor, data,payment_mode) =>{
    const collectionReportName = "Collection Report", upiReportName = "UPI Summary";
    let columns = {};

    const format = getDownloadFormat(type);
    switch (downloadFor) {
      case "collectionReport":
        const rows = formatForPdfData(data,payment_mode)
        if(type === "pdf"){
          columns = dataColumn 
        } else {
          columns = dataColumnCsv 
        }
       return { header: collectionReportName, rows: rows, columns, widths: defaultColumnWidths, name:`${collectionReportName}${format}`  }
        
      case "upiSummary":
        const upiRows = formatPdfDataForUpi(data)
        
        if(type === "pdf"){
          columns = upiColumn
        } else {
          columns = upiColumnCsv 
        }
        return { header: upiReportName, rows: upiRows, columns, widths: defaultColumnWidths, name:`${upiReportName}${format}`   }
    
      default:
        break;
    }
  }

  async function downloadPDF(type, downloadFor) {
    setIsLoader(true);
    try {
      let params = "";
      const agentIdValue = filterVal.agentId;
      const agentNameValue = filterVal.agentName;
      const chittalNoValue = filterVal.ChittalNo;
      const postIdValue = filterVal.postId;
      const chittyIdValue = filterVal.chittyId;
      const startDateValue =filterVal?.Date?.[0] ? convertToUTC(filterVal?.Date?.[0]) : moment().subtract(1, 'days').format('DD-MM-YYYY');
      const endDateValue =filterVal?.Date?.[1] ? convertToUTC(filterVal?.Date?.[1]) : moment().format('DD-MM-YYYY');
      const casbaStatusValue = filterVal.casba;
      const paymentModeValue=filterVal.payment_mode;
      const transactionId = filterVal.transactionId;
      const branch_name = filterVal.branch_name;
      const Region_name = filterVal.region_name;
      const customer_Name = filterVal.customer_name;
      if (collectionsTableVisible) {
        params = agentNameValue ? `agentName=${agentNameValue}&` : "";
        params = params + (agentIdValue ? `agentId=${agentIdValue}&` : "");
        params =
          params + (transactionId ? `transactionId=${transactionId}&` : "");
        params = params + (branch_name ? `branchId=${branch_name}&` : "");
        params = params + (Region_name ? `regionCode=${Region_name}&` : "");
        params = params + (paymentModeValue ? `paymentMode=${paymentModeValue}&` : "");
        params =
          params +
          (startDateValue && endDateValue
            ? `startDate=${startDateValue}&endDate=${endDateValue}&`
            : "");
      } else {
        params = customer_Name ? `customerName=${customer_Name}&` : "";
        params = chittalNoValue ? `chittalNo=${chittalNoValue}&` : "";
        params = params + (chittyIdValue ? `chit_id=${chittyIdValue}&` : "");
        params = params + (postIdValue ? `syncId=${postIdValue}&` : "");
        params =
          params +
          (startDateValue && endDateValue
            ? `startDate=${startDateValue}&endDate=${endDateValue}&`
            : "");
        params =
          params + (casbaStatusValue ? `status=${casbaStatusValue}&` : "");
      }
      params = params + "hasPagination=true";
      const path = collectionsTableVisible
        ? `${global.baseUrl}${global.getCollectionDetails}?${params}`
        : `${global.baseUrl}${global.getSchemeDetails}?${params}`;
      const reqstBody = {};
      const method = "get";

      const result = await commonApiCall({ path, reqstBody, method });
      if (result.message === "Success") {
        const data = getDownloadDetails(type, downloadFor, result?.response_data?.data,paymentModeValue);
        downloadDifferentType(type, data);
        
      } else {
        console.error("Error downloading PDF:", result.message);
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
    } finally {
      setIsLoader(false);
    }
  }

  const handleAlertClose = () =>{ 
    setShowAlert(AlertinitialValue)
    fetchTableDatas();
  }

  const handleConfirmModalClose = (status) =>{
    if(remark && status){
      handleDelete();
      return;
    }
    setFilterVal((pre)=>({...pre,remark:""}))
    setRemark()
    setShowConfirmModal(false)
    if(status){
      handleCheckPaymentStatus(null,selectedRecord,false);
    }
  }

  return (
    <>
      <ConfirmationModal
      handleClose={()=>handleConfirmModalClose(false)}
      visible={showConfirmModal || remark}
      title={remark ? "Add a remark" : "Are you sure?"}
      confirmMessage={!remark && "Are you sure you want to update the status?"}
      handleConfirm={()=>handleConfirmModalClose(true)}
      remark={remark}
      value={filterVal.remark}
      handleOnchange={handleOnChange}
      />
        <AlertBox
        show={showAlert.show}
        message={showAlert.message}
        enableFailIcon={showAlert.isFalse}
        enableSuccessIcon={showAlert.isSuccess}
        handlecancel={handleAlertClose}
        hideCloseBtn={showAlert.hideCloseBtn}
      />
      <div className="d-flex justify-content-between ">
        <div className="d-flex">
          <div
            className={`bg_light7 position-relative headStyle1  w_fit_content min_w_160x px-4 pt-3 pb-2 ${
              selectedTab === "collections" ? "active-tab" : ""
            }`}
            onClick={() => handleTabChange("collections")}
            style={{ cursor: "pointer" }}
          >
            <h2 className="mb-0 collection_details mt-0 cursor-pointer text-start text_master font_16 font_500">
            Collection Details
            </h2>
            <div
              className={`headStyle ${
                selectedTab === "collections" ? "headStyle-active" : ""
              }`}
            ></div>
          </div>
          <div
            className={`ms-3 bg_light7 position-relative headStyle1 shadow_sm_4 w_fit_content min_w_160x px-4 pt-3 pb-2 ${
              selectedTab === "schemeDetails" ? "active-tab" : ""
            }`}
            onClick={() => handleTabChange("schemeDetails")}
            style={{ cursor: "pointer" }}
          >
            <h2 className="mb-0 mt-0 Transaction_details text-start text_master font_16 font_500">
              Scheme Details
            </h2>
            <div
              className={`headStyle ${
                selectedTab === "schemeDetails" ? "headStyle-active" : ""
              }`}
            ></div>
          </div>
        </div>
        <div className="d-flex gap-2">
          {TableData?.length > 0 && (
            <>
            <DownloadComponent
              options={downloadOptions}
              onDownload={downloadPDF}
              type="collectionReport"
            />
            <DownloadComponent
              options={downloadOptions}
              onDownload={downloadPDF}
              btnName="UPI Summary"
              type="upiSummary"
            />
            </>
          )}
          <FilterComponent
            filterInputData={filterChange}
            handleChange={handleOnChange}
            handleReset={handleFilterReset}
            scheme={selectedTab !== "collections" ?true: false}
            value={filterVal}
            populateBranchOptions={() => filterListOptions()}
            errorMsg={errorMsg}
            handleApply={() => {
              fetchTableDatas(1);
              setFilter(true);
            }}
            resetEnabled={filter}
            onclear={handleOnChange}
          ></FilterComponent>
        </div>
      </div>

      {collectionsTableVisible && (
        <div className="pb-3  custom_pagination customise_table3 customise_table customise_Expand_table expandable-table shadow_sm_4 br_15  ">
          <DataTable
            rowData={TableData}
            columns={collectionData}
            expandedRowRender={expandedRowRender}
            currentPage ={currentPage}
            pageSize={pageSize}
            onChangeTable={(current, Size) => onChangeTable(current, Size)}
            scroll={TableData.length > 5 ? { y: 400 } : ""}
            changeIcon={setisExpand}
            total={TotalCount}
            setPageSize={setpageSize}
          />
        </div>
      )}
      {VisibleschemeDetails && (
        <>
          <div className=" pb-3  custom_pagination customise_table3 customise_table customise_Expand_table expandable-table shadow_sm_4 br_15  ">
            <DataTable
              rowData={TableData}
              columns={SchemeData}
              pageSize={pageSize}
              currentPage={currentPage}
              expandedRowRender={expandedRowRender}
              changeIcon={setisExpand}
              total={TotalCount}
              keyIsTrue={true}
              onChangeTable={(current, Size) => onChangeTable(current, Size)}
              scroll={TableData.length > 5 ? { y: 400 } : ""}
              setPageSize={setpageSize}
            />
          </div>
        </>
      )}
    </>
  );
}

export default Collections;
